/* lua.js generated code 0.3.0 */

MusicPlayer = xClass('MusicPlayer')

GameMusicType = table.const(table(
    [1, "kContinueMatch", "music/sound.contnuousMatch.%d.mp3"],
    [1, "kSlide", "music/sound.DropSlide.mp3"],
    [1, "kDrop", "music/sound.Drop.mp3"],
    [1, "kEliminate", "music/sound.Eliminate%d.mp3"],
    [1, "kEliminateTip", "music/sound.EliminateTip.mp3"],
    [1, "kBonusTime", "music/sound.bonus.time.mp3"],
    [1, "kWorldSceneBGM", "music/sound.WorldSceneBGM.mp3"],
    [1, "kGameSceneBGM", "music/sound.GameSceneBGM.mp3"],
    [1, "kPreEnterGame", "music/sound.PreEnterGameBGM.mp3"],
    [1, "kBossModeBGM", "music/sound.mode_boss_bgm.mp3"],
    [1, "kBonusTimeBGM", "music/sound.bonusBGM.mp3"],
    [1, "kCreateLine", "music/sound.create.strip.mp3"],
    [1, "kCreateFourTile", "music/sound.create.fourTile.mp3"],
    [1, "kCreateWrap", "music/sound.create.wrap.mp3"],
    [1, "kCreateColor", "music/sound.create.color.mp3"],
    [1, "kCreateAlien", "music/sound.create.alien.mp3"],
    [1, "kCreateSuperBird", "music/sound.create.superbird.mp3"],
    [1, "kEliminateLine", "music/sound.eliminate.strip.mp3"],
    [1, "kEliminateWrap", "music/sound.eliminate.wrap.mp3"],
    [1, "kEliminateFourTile1", "music/sound.eliminate.fourTile1.mp3"],
    [1, "kEliminateFourTile2", "music/sound.eliminate.fourTile2.mp3"],
    [1, "kEliminateSuperBird", "music/sound.eliminate.superBird.mp3"],
    [1, "kEliminateMissile", "music/sound.eliminate.missile.mp3"],
    [1, "kEliminateHoneyBottle", "music/sound.eliminate.honeybottle.mp3"],
    [1, "kEliminateHoney", "music/sound.eliminate.honey.mp3"],
    [1, "kEliminateCage", "music/sound.eliminate.cage.mp3"],
    [1, "kEliminateDandelion", "music/sound.eliminate.dandelion.mp3"],
    [1, "kEliminateVariousBox", "music/sound.eliminate.variousbox.mp3"],
    [1, "kEliminateChains", "music/sound.eliminate.chains.mp3"],
    [1, "kEliminateColor", "music/sound.eliminate.color.mp3"],
    [1, "kEliminateGum", "music/sound.eliminate.gum.mp3"],
    [1, "kSnowBreak", "music/sound.frosint.break.mp3"],
    [1, "kIceBreak", "music/sound.ice.break.mp3"],
    [1, "kBonusStepToLine", "music/sound.step.to.line.mp3"],
    [1, "kJumpOutItemOnBoard", "music/jump.item.on.board.mp3"],
    [1, "kSwapColorColorSwap", "music/sound.swap.colorcolor.swap.mp3"],
    [1, "kSwapDoubleSuperBird", "music/sound.swap.double.superBird.mp3"],
    [1, "kSwapDoubleSuperBirdCleanAll", "music/sound.swap.double.superBird.cleanall.mp3"],
    [1, "kSwapColorSuperBird", "music/sound.swap.colorSuperBird.mp3"],
    [1, "kSwapColorSuperBirdCleanAll", "music/sound.swap.colorSuperBird.cleanall.mp3"],
    [1, "kSwapLineLine", "music/sound.swap.lineline.mp3"],
    [1, "kSwapWrapLine", "music/sound.swap.wrapline.mp3"],
    [1, "kSwapWrapWrap", "music/sound.swap.wrapwrap.mp3"],
    [1, "kSwitchWrapLine", "music/sound.switch.wrapline.mp3"],
    [1, "kSwitchWrapWrap", "music/sound.switch.wrapwrap.mp3"],
    [1, "kColorLight", "music/sound.color.light.mp3"],
    [1, "kSuperLight", "music/sound.super.light.mp3"],
    [1, "kSwapSuperBirdSpecial", "music/sound.swap.superbirdspecial.mp3"],
    [1, "kSwapFourTileLine1", "music/sound.swap.fourTileLine1.mp3"],
    [1, "kSwapFourTileLine2", "music/sound.swap.fourTileLine2.mp3"],
    [1, "kSwapFourTileWrap1", "music/sound.swap.fourTileWrap1.mp3"],
    [1, "kSwapFourTileWrap2", "music/sound.swap.fourTileWrap2.mp3"],
    [1, "kSwapDoubleFourTile1", "music/sound.swap.doubleFourTile1.mp3"],
    [1, "kSwapDoubleFourTile2", "music/sound.swap.doubleFourTile2.mp3"],
    [1, "kModeOrderAnimalAppear", "music/sound.mode_order_animal_appear_1.mp3"],
    [1, "kModeOrderBottleSlide", "music/sound.mode_order_bottle_slide_2.mp3"],
    [1, "kModeOrderJellyFall", ""],//sound.mode_order_jelly_fall_into_bottle_5.mp3
    [1, "kModeOrderTargetFinish", "music/sound.mode_order_target_finish_animal_leave_4.mp3"],
    [1, "kModeOrderTargetFlyToBottle", ""],//sound.mode_order_target_fly_to_bottle_3.mp3
    [1, "kModeOrderThingsFall", ""],// "music/sound.mode_order_things_fall_into_bottle_6.mp3"],
    [1, "kModeOrderThingsFall_1", ""],//sound.mode_order_things_fall_into_bottle_6_1.mp3
    [1, "kModeCollectThingsFall", "music/sound.mode_collect_fall_into_bottle.mp3"],
    [1, "kModeIceShovelIcecream", "music/sound.mode_ice_bear_shovel_icecream_14.mp3"],
    [1, "kModeIceFinishOneTarget", "music/sound.mode_ice_finish_one_target_15.mp3"],
    [1, "kModeIceFruitFly", "music/sound.mode_ice_fruit_fly_to_target_13.mp3"],
    [1, "kModeIceFogSpray", "music/sound.mode_ice_fog_spray.mp3"],
    [1, "kModeIceFruitOut", "music/sound.mode_ice_fruit_out.mp3"],
    [1, "kModeIceChickenAppear", "music/sound.mode_icecream_chick_appear.mp3"],
    [1, "kModeIcePassMission", ""],
    [1, "kModeFishCatPull", "music/sound.mode_fish_cat_pull_10.mp3"],
    [1, "kModeFishFishFly", ""],//sound.mode_fish_fish_fly_to_target_8.mp3
    [1, "kModeFishFishSpring", "music/sound.mode_fish_fish_spring_out_7.mp3"],
    [1, "kModeFishFishSwim", "music/sound.mode_fish_fish_swim_9.mp3"],
    [1, "kBossAppear", "music/sound.mode_boss_appear.mp3"],
    [1, "kAnimalAttackBoss", "music/sound.mode_boss_animal_attack.mp3"],
    [1, "kBigBossBeHeavyHit", "music/sound.mode_boss_be_hit_heavy_big.mp3"],
    [1, "kSmallBossBeHeavyHit", "music/sound.mode_boss_be_hit_heavy_small.mp3"],
    [1, "kPetAttack_1", "music/sound.mode_boss_pet_attack_hippo.mp3"],
    [1, "kPetAttack_5", "music/sound.mode_boss_pet_attack_fox.mp3"],
    [1, "kPetAttack_4", "music/sound.mode_boss_pet_attack_owl.mp3"],
    [1, "kPetAttack_2", "music/sound.mode_boss_pet_attack_frog.mp3"],
    [1, "kPetAttack_6", "music/sound.mode_boss_pet_attack_chick.mp3"],
    [1, "kPetAttack_3", "music/sound.mode_boss_pet_attack_bear.mp3"],
    [1, "kBossBlockAttack", "music/sound.mode_boss_block_attack.mp3"],
    [1, "kWinLevel", "music/sound.game.win.level.mp3"],
    [1, "kLoseLevel", "music/sound.game.lose.level.mp3"],
    [1, "kBasePanelOpen", "music/sound.ui.base_panel_open.mp3"],
    [1, "kBtnClick", "music/sound.ui.btn.click.mp3"],
    [1, "kLevelTargetPanelShow", "music/sound.ui.level_target_panel_show.mp3"],
    [1, "kGetNewStar", "music/sound.clipStar.mp3"],
    [1, "kGetFourStar", "music/sound.clipStar.four.mp3"],
    [1, "kGameModeTargetBubbleOut", "music/sound.target.bubble.out.mp3"],
    [1, "kLaserFire", "music/laser.fire.mp3"],
    [1, "kLaserCollect", "music/laser.collect.mp3"],
    [1, "kLaserReady", "music/laser.ready.mp3"],
    [1, "kDinnertableBreak", "music/dinnertable.break.mp3"],
    [1, "kBiscuitBreak1", "music/biscuit.break1.mp3"],
    [1, "kBiscuitBreak2", "music/biscuit.break2.mp3"],
    [1, "kFilbertBreak", "music/filbert.break.mp3"],
    [1, "kCrabBreak1", "music/crab.break1.mp3"],
    [1, "kCrabBreak2", "music/crab.break2.mp3"],
    [1, "kCrabMove", "music/crab.move.mp3"],
    [1, "kCheeseRatBreak", "music/cheese_rat.break.mp3"],
    [1, "kCheeseRatJump", "music/cheese_rat.jump.mp3"],
    [1, "kCheeseRatRun", "music/cheese_rat.run.mp3"],
    [1, "kVulnerableBreak", "music/vulnerable.break.mp3"],
    [1, "kVulnerableFail", "music/vulnerable.fail.mp3"],
    [1, "kBowknotBreak", "music/bowknot.break.mp3"],
    [1, "kBowknotFly", "music/bowknot.fly.mp3"],
    [1, "kPopcornBreak", "music/popcorn.break.mp3"],
    [1, "kPopcornFall", "music/popcorn.fall.mp3"],
    [1, "kCandyFlossBreak", "music/candyFloss.break.mp3"],
    [1, "kCakeshooterFire", "music/cakeShooter.fire.mp3"],
    [1, "kPopcanCharge", "music/popcan.charge.mp3"],
    [1, "kPopcanFire", "music/popcan.fire.mp3"],
    [1, "kRocketFire", "music/rocket.fire.mp3"],
    [1, "kRocketBomb", "music/rocket.bomb.mp3"],
    [1, "kJamjarBreak", "music/jamJar.break.mp3"],
    [1, "kJamjarJump", "music/jamJar.jump.mp3"],
    [1, "kJamjarDye", "music/jamJar.dye.mp3"],
    [1, "kWrackBreak", "music/wrack.break.mp3"],
    [1, "kMintCharge", "music/mint.charge.mp3"],
    [1, "kMintReady", "music/mint.ready.mp3"],
    [1, "kMintFire", "music/mint.fire.mp3"],
    [1, "kRattanFall", "music/rattan.fall.mp3"],
    [1, "kRattanFlower", "music/rattan.flower.mp3"],
    [1, "kCocoBreak", "music/coco.break.mp3"],
    [1, "kCakeBreak", "music/cake.break.mp3"],
    [1, "kPastryBreak", "music/pastry.break.mp3"],
    [1, "kEggBreak", "music/egg.break.mp3"],
    [1, "kGummywormPush", "music/gummyWorm.push.mp3"],
    [1, "kTorpedoCollect", "music/torpedo.collect.mp3"],
    [1, "kTorpedoReady", "music/torpedo.ready.mp3"],
    [1, "kTorpedoFire", "music/torpedo.fire.mp3"],
    [1, "kCandyyoyoPush", "music/candyYoyo.push.mp3"],
    [1, "kCandyyoyoDown", "music/candyYoyo.down.mp3"],
    [1, "kRatelWakeup", "music/ratelBoss.wakeup.mp3"],
    [1, "kRatelPush", "music/ratelBoss.push.mp3"],
    [1, "kBombcandyBreak", "music/bombCandy.break.mp3"],
    [1, "kBombcandyBomb", "music/bombCandy.bomb.mp3"],
    [1, "kWaterbombFire", "music/waterbomb.fire.mp3"],
    [1, "kSandBreak", "music/sand.break.mp3"],
    [1, "kGrassOpen", "music/grass.open.mp3"],
    [1, "kVenomBreak", "music/venom.break.mp3"],
    [1, "kVenomMove", "music/venom.move.mp3"],
    [1, "kJellyfishSwim", "music/jellyfish.swim.mp3"],
    [1, "kJellyfishVenom", "music/jellyfish.venom.mp3"],
    [1, "kNestShake", "music/nest.shake.mp3"],
    [1, "kNestBird", "music/nest.bird.mp3"],
    [1, "kBeehiveLight", "music/beehive.light.mp3"],
    [1, "kBeehiveFire", "music/beehive.fire.mp3"],
    [1, "kColorCollect", "music/color_collect.collect.mp3"],
    [1, "kColorCollectReady", "music/color_collect.ready.mp3"],
    [1, "kColorCollectStrike", "music/color_collect.strike.mp3"],
    [1, "kMushroomBreak", "music/mushroom.break.mp3"],
    [1, "kMushroomFall", "music/mushroom.fall.mp3"],
    [1, "kFlashBirdCollect", "music/flash_bird.collect.mp3"],
    [1, "kFlashBirdWakeup", "music/flash_bird.wakeup.mp3"],
    [1, "kFlashBirdFire", "music/flash_bird.fire.mp3"],
    [1, "kIcebombBreak", "music/iceBomb.break.mp3"],
    [1, "kIcebombBomb", "music/iceBomb.bomb.mp3"],
    [1, "kIcecreamDec", "music/icecream.break1.mp3"],
    [1, "kIcecreamCollectDec", "music/icecream.break2.mp3"],
    [1, "kIcecreamBombHint", "music/icecream.light.mp3"],
    [1, "kIceballBreak", "music/iceball.break.mp3"],
    [1, "kLampLight", "music/lamp.light.mp3"],
    [1, "kLampBreak", "music/lamp.break.mp3"],
    [1, "kLampBomb", "music/lamp.bomb.mp3"],
    [1, "kCroissantBreak1", "music/croissant.break1.mp3"],
    [1, "kCroissantBreak2", "music/croissant.break2.mp3"],
    [1, "kCroissantBreak3", "music/croissant.break3.mp3"],
    [1, "kAnemoneBreak1", "music/seaAnemone.break1.mp3"],
    [1, "kAnemoneBreak2", "music/seaAnemone.break2.mp3"],
    [1, "kAnemoneRoll", "music/seaAnemone.rollback.mp3"],
    [1, "kNestDollBreak1", "music/nestDoll.break1.mp3"],
    [1, "kNestDollBreak2", "music/nestDoll.break2.mp3"],
    [1, "kNestDollFly", "music/nestDoll.fly.mp3"],
    [1, "kFirecrackerFire", "music/firecracker.fire.mp3"],
    [1, "kFirecrackerStrike", "music/firecracker.strike.mp3"],
    [1, "kColoredFrostBreak1", "music/coloredFrosting.break1.mp3"],
    [1, "kColoredFrostBreak2", "music/coloredFrosting.break2.mp3"],
    [1, "kOrgangeBreak", "music/orange.break.mp3"],
    [1, "kSurpriseBreak1", "music/surprise.break1.mp3"],
    [1, "kSurpriseBreak2", "music/surprise.break2.mp3"],
    [1, "kHunterBreak", "music/hunter.break.mp3"],
    [1, "kHunterFire", "music/hunter.fire.mp3"],
    [1, "kHunterDisappear", "music/hunter.disappear.mp3"],
    [1, "kDiamondBreak", "music/diamond.break.mp3"],
    [1, "kTurnTileAttack", "music/turnTile.hit.mp3"],
    [1, "kTurnTilePrepare", "music/turnTile.prepare.mp3"],
    [1, "kTurnTileTrigger", "music/turnTile.trigger.mp3"],
    [1, "kTurnTileFlip1", "music/turnTile.flip1.mp3"],
    [1, "kTurnTileFlip2", "music/turnTile.flip2.mp3"],
    [1, "kCannedFishFinish", "music/cannedfish.finish.mp3"],
    [1, "kCannedFishOpen", "music/cannedfish.open.mp3"],
    [1, "kCannedFishFishBreak", "music/cannedfish.break.mp3"],
    [1, "kSharkFire", "music/shark.fire.mp3"],
    [1, "kSharkDie", "music/shark.die.mp3"],
    [1, "kEnterShop", "music/sound.enter.shop.mp3"],
    [1, "kJamDescent", "music/jam.Descent.mp3"],
    [1, "kJamBoxBroken", "music/jamBox.Broken.mp3"],
    [1, "kJamBoxDrop", "music/jamBox.Drop.mp3"],
    [1, "kJamBoxPotlidDrop", "music/jamBox.Potlid.Drop.mp3"],
    [1, "kFoamBombBomb", "music/foambomb.bomb.mp3"],
    [1, "kFoamBombDec", "music/foambomb.dec.mp3"],
    [1, "kFoamBombReadyBomb", "music/foambomb.readybomb.mp3"],
    [1, "kIcePopBoxBreak1", "music/icepopbox.break1.mp3"],
    [1, "kIcePopBoxBreak2", "music/icepopbox.break2.mp3"],
    [1, "kIcePopBoxBreak3", "music/icepopbox.break3.mp3"],
    [1, "kIcePopBoxBroken", "music/icepopbox.broken.mp3"],
    [1, "kIcePopHit", "music/icepopbox.hit.mp3"],
    [1, "kSafeBreak1", "music/safe.break1.mp3"],
    [1, "kSafeBreak2", "music/safe.break2.mp3"],
    [1, "kSafeBroken", "music/safe.broken.mp3"],
    [1, "kSafeHit", "music/safe.hit.mp3"],
    [1, "kCircusBallBreak1", "music/circusBall.break1.mp3"],
    [1, "kCircusBallBreak2", "music/circusBall.break2.mp3"],
    [1, "kCircusACollect", "music/circus.collect.mp3"],
    [1, "kCircusA2B", "music/circus.open.mp3"],
    [1, "kCircusBBreak", "music/circus.break.mp3"],
    [1, "kCircusBActive", "music/circus.ready.mp3"],
    [1, "kCircusBStarFly", "music/circus.shot.mp3"],
    [1, "kWoodBoxBreak", "music/woodbox.break.mp3"],
    [1, "kWoodBoxCut", "music/woodbox.cut.mp3"],
    [1, "kCandyCaneBreak", "music/candycane.break.mp3"],
    [1, "kWMangosteenBreak", "music/mangosteen.break.mp3"],
    [1, "kMangosteenDec", "music/mangosteen.dec.mp3"],
    [1, "kTetrisDrop", "music/sound.tetris.drop.mp3"],
    [1, "kTetrisFail", "music/sound.tetris.fail.mp3"],
    [1, "kTetrisMatch", "music/sound.tetris.match.mp3"]
))
var instance = null
MusicPlayer.prototype.ctor = function () {
    var self = this
    TODO("音乐默认关掉")
    self.IsMusicOpen = !cc.UserDefault.getInstance().getBoolForKey("game.disable.sound.effect")
    self.IsBackgroundMusicOpen = !cc.UserDefault.getInstance().getBoolForKey("game.disable.background.music")
    self.normalBgMusicVolume = cc.SimpleAudioEngine.getInstance().getMusicVolume()
    self.curBgMusicFile = false
    self.bgMusicDelay = -1
    self.iosVideoPlay = false
    self.isAppPaused = false
}
MusicPlayer.prototype.enterBackground = function () {
    var self = this
    if (self.IsMusicOpen) {
        cc.SimpleAudioEngine.getInstance().pauseAllEffects()
    }

    if (self.IsBackgroundMusicOpen) {
        //cc.SimpleAudioEngine.getInstance().stopMusic(true)
        cc.SimpleAudioEngine.getInstance().stopEffect(self._bgAudio)
        self.disposeBgMusicDelay()
    }
    self.disposeBgMusicDelay()
}


MusicPlayer.prototype.playCurrentBGMusic = function (isloop) { 
    var self = this
    isloop =  isloop || false
    self._bgMusic = cc.SimpleAudioEngine.getInstance();
    self._bgMusic.stopEffect(self._bgAudio)
    self._bgAudio = self._bgMusic.playEffect(self.curBgMusicFile, isloop, self.finish, self)

}

MusicPlayer.prototype.stopCurrentBGMusic = function () {
     var self = this
     cc.SimpleAudioEngine.getInstance().stopEffect(self._bgAudio)

}


MusicPlayer.prototype.enterForeground = function () {
    var self = this
    if (self.isAppPaused) {
        return
    }
    if (cc.director.getRunningScene() && cc.director.getRunningScene().name === "TetrisGameScene") {
        TetrisLogic.getInstance().data.playEffect(GameMusicType.kGameSceneBGM, true)
        return
    }
    if (self.IsBackgroundMusicOpen) {
        if (self.curBgMusicFile) {
            // 进入前台的时候延迟播放因为，因为 微信 iOS 在静音模式下直接播放会有问题
            // 现在采取的解决方案就是延迟执行
            setTimeout(() => {
                self.playCurrentBGMusic()
            }, 1000);
        }
    }
    if (self.IsMusicOpen) {
        cc.SimpleAudioEngine.getInstance().resumeAllEffects()
    }
    if (self.iosVideoPlay) {
        self.oncePauseBackgroundMusic()
    }
}
MusicPlayer.prototype.appPause = function () {
    var self = this
    if (self.IsBackgroundMusicOpen) {
        self.stopCurrentBGMusic();
    }
    if (self.IsMusicOpen) {
        cc.SimpleAudioEngine.getInstance().pauseAllEffects()
    }
    if (_G.needCheckMusicCanPlay) {
        self.isAppPaused = true
    }
}
MusicPlayer.prototype.appResume = function () {
    var self = this
    if (self.isVideoPlay) {
        return
    }
    self.isAppPaused = false
    if (self.IsBackgroundMusicOpen) {
        if (self.curBgMusicFile) {
            function cb() {
                if (!self.isAppPaused && !cc.SimpleAudioEngine.getInstance().isMusicPlaying()) {
                    self.playCurrentBGMusic();
                }
                self.disposeBgMusicDelay()
            }
            if (self.iosVideoPlay) {
                self.disposeBgMusicDelay()
            } else {
                self.bgMusicDelay = cc.Director.getInstance().getScheduler().scheduleScriptFunc(cb, 1, false)
            }
        }
    }
    if (self.IsMusicOpen) {
        cc.SimpleAudioEngine.getInstance().resumeAllEffects()
    }
}
MusicPlayer.prototype.disposeBgMusicDelay = function () {
    var self = this
    if (self.bgMusicDelay >= 0) {
        cc.Director.getInstance().getScheduler().unscheduleScriptEntry(self.bgMusicDelay)
        self.bgMusicDelay = -1
    }
}
MusicPlayer.prototype.pauseBackgroundMusic = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    self.IsBackgroundMusicOpen = false
    //cc.SimpleAudioEngine.getInstance().stopMusic(true)

    self.stopCurrentBGMusic()

    var config = cc.UserDefault.getInstance()
    config.setBoolForKey("game.disable.background.music", true)
    config.flush()
    self.disposeBgMusicDelay()
}
MusicPlayer.prototype.resumeBackgroundMusic = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    self.IsBackgroundMusicOpen = true
    if (self.curBgMusicFile) {
        //cc.SimpleAudioEngine:getInstance():setBackgroundMusicVolume(self.normalBgMusicVolume)
        self.playCurrentBGMusic();
    }
    var config = cc.UserDefault.getInstance()
    config.setBoolForKey("game.disable.background.music", false)
    config.flush()
}

MusicPlayer.prototype.oncePauseBackgroundMusic = function () {
    var self = this
    if (__IOS) {
        self.iosVideoPlay = true
    }
    // body
    if (self.IsBackgroundMusicOpen) {
        //self._bgMusic = cc.SimpleAudioEngine.getInstance();
        //if (self._bgMusic) self._bgMusic.pauseMusic(true)
    }
}
MusicPlayer.prototype.onceResumeBackgroundMusic = function () {
    var self = this
    if (__IOS) {
        self.iosVideoPlay = false
    }
    // body
    if (self.IsBackgroundMusicOpen) {
        //self._bgMusic = cc.SimpleAudioEngine.getInstance();
        //if (self._bgMusic) self._bgMusic.resumeMusic()
    }
}
MusicPlayer.prototype.pauseSoundEffects = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    self.IsMusicOpen = false
    var config = cc.UserDefault.getInstance()
    config.setBoolForKey("game.disable.sound.effect", true)
    config.flush()
}
MusicPlayer.prototype.resumeSoundEffects = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    assert($len(table([2, __VA_ARG])) === 0)
    self.IsMusicOpen = true
    var config = cc.UserDefault.getInstance()
    config.setBoolForKey("game.disable.sound.effect", false)
    config.flush()
}
MusicPlayer.getInstance = function () {
    if (!instance) {
        instance = MusicPlayer.new()
    }
    return instance
}


MusicPlayer.prototype.finish = function (self, audio) {  //异步完成后设置背景音乐句柄
    self._bgAudio = audio
}


//--------------------------------
//播放其他文件为背景音乐
//mp3Path  文件地址
//--------------------------------
MusicPlayer.prototype.playOtherBgMusic = function (mp3Path, loop) {
    var self = this
    if (self.isAppPaused) {
        return
    }
    var isLoop = false
    if (loop) {
        isLoop = true
    }
    if (self.curBgMusicFile !== mp3Path) {
        self.curBgMusicFile = mp3Path
        if (self.IsBackgroundMusicOpen) {
            self.playCurrentBGMusic(isLoop)
        } else {
            // Do Nothing
        }
    }
}
MusicPlayer.prototype.playWorldSceneBgMusic = function (Volume) { 
    //var __VA_ARG = $slice(arguments, 1)
    var self = this
    //assert($len(table([2, __VA_ARG])) === 0)
    //cc.log('playWorldSceneBgMusic:'+self.IsBackgroundMusicOpen );
    if (self.curBgMusicFile !== GameMusicType.kWorldSceneBGM) {
        self.curBgMusicFile = GameMusicType.kWorldSceneBGM

        // if (self.IsBackgroundMusicOpen) {
        //     //cc.log('playWorldSceneBgMusic!:'+self.IsBackgroundMusicOpen );
        //     self.playCurrentBGMusic(true)
        // } else {
        //     // Do Nothing
        // }
    }else{  
        //cc.log('playWorldSceneBgMusic*!:'+self.curBgMusicFile );
    }
    if (self.IsBackgroundMusicOpen) {
        //cc.log('playWorldSceneBgMusic!:'+self.IsBackgroundMusicOpen );
        self.playCurrentBGMusic(true)
    } else {
        // Do Nothing
    }
}

MusicPlayer.prototype.preloadMusic = function (music) {
    cc.SimpleAudioEngine.getInstance().preloadMusic(music)
}

MusicPlayer.prototype.playGameSceneBgMusic = function () {
    //var __VA_ARG = $slice(arguments, 0)
    var self = this
    //assert($len(table([2, __VA_ARG])) === 0)
    self.curBgMusicFile = GameMusicType.kGameSceneBGM
    if (self.IsBackgroundMusicOpen) {
       self.playCurrentBGMusic(true)
    } else {
        // Do Nothing
    }
}
MusicPlayer.prototype.stopBgMusic = function () {
    var self = this
    if (self.IsBackgroundMusicOpen) {
        self.stopCurrentBGMusic();
    }
}
MusicPlayer.playEffect = MusicPlayer.prototype.playEffect = function (filename, vol) {
    var self = this
    if (!filename || filename === "") {
         return
    }
    var context = self
    function setEffectLifeDead() {
        context.effectLifeCycle[filename] = false
    }
    if (MusicPlayer.getInstance().IsMusicOpen && !(__WIN32 && cc.Director.getInstance().isInNoViewMode && cc.Director.getInstance().isInNoViewMode())) {
        if (self.effectLifeCycle == null) {
            self.effectLifeCycle = table()
        }
        if (self.effectLifeCycle[filename]) {
            return
        } else {
            self.effectLifeCycle[filename] = true
            setTimeOut(setEffectLifeDead, 0.1)
            cc.SimpleAudioEngine.getInstance().playEffect(filename)
        }
    }
}
MusicPlayer.stopEffect = MusicPlayer.prototype.stopEffect = function (effectInstance) {
    let self = this
    if (effectInstance) {
        cc.SimpleAudioEngine.getInstance().stopEffect(effectInstance)
    }
}
